import React, { Component } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Fade } from "react-reveal";
import "./IssueChart.scss";
import IssueData from "../../shared/opensource/issues.json";

ChartJS.register(ArcElement, Tooltip, Legend);

class IssueChart extends Component<Record<string, never>> {
  render() {
    const issues = IssueData.data || [];
    const open = issues.filter((i) => i.closed === false).length;
    const closed = issues.filter((i) => i.closed === true).length;

    const data = {
      labels: ["Open", "Closed"],
      datasets: [
        {
          data: [open, closed],
          backgroundColor: ["#28a745", "#d73a49"],
          hoverBackgroundColor: ["#28a745dd", "#d73a49dd"],
        },
      ],
    };

    return (
      <div className="issue-chart">
        <Fade bottom duration={2000} distance="20px">
          <h2 className="issue-chart-header">Issue Distribution</h2>
        </Fade>
        <Doughnut
          data={data}
          options={{
            responsive: true,
            maintainAspectRatio: true,
            animation: {
              duration: 4000,
            },
          }}
        />
      </div>
    );
  }
}

export default IssueChart;
